<app-tab-navigation-header title="User" i18n-title="@@userDetail-usersTitle" detail="{{ userName }}">
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab label="Details" i18n-label="@@user-detailAboutLabel" data-automation-id="details-tab">
			<ng-template matTabContent>
				@if (user !== undefined) {
					<app-user-about [appBreadcrumbLabel]="aboutBreadcrumbLabel" [user]="user"></app-user-about>
				}
			</ng-template>
		</mat-tab>

		@if (this.canAccessEventHistory) {
			<mat-tab label="Access History" i18n-label="@@user-detailEventHistory" data-automation-id="access-history-tab">
				<ng-template matTabContent>
					<app-user-event-history
						[appBreadcrumbLabel]="accessHistoryBreadcrumbLabel"
						[user]="user"
						[companyId]="companyId"
					></app-user-event-history>
				</ng-template>
			</mat-tab>
		}

		@if (this.canAccessAuditLogs) {
			<mat-tab label="Audit Log" i18n-label="@@user-detailsAuditLog2" data-automation-id="audit-log-tab">
				<ng-template matTabContent>
					<app-audit-log-list [userId]="userId" [appBreadcrumbLabel]="auditLogBreadcrumbLabel"></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
